var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotiInitiatives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 14.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 26") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.59,4.71H14.71a.59.59,0,0,1,.59.59v8.82a.59.59,0,0,1-.59.59H.59A.59.59,0,0,1,0,14.12V5.29A.59.59,0,0,1,.59,4.71Zm15.88,7.35V3.53H2.65a.3.3,0,0,1-.29-.3V2.65a.29.29,0,0,1,.29-.3H17.06a.59.59,0,0,1,.59.59v9.12a.3.3,0,0,1-.3.29h-.58A.29.29,0,0,1,16.47,12.06Zm2.35-2.35V1.18H5a.3.3,0,0,1-.29-.3V.3A.29.29,0,0,1,5,0H19.41A.59.59,0,0,1,20,.59V9.71a.3.3,0,0,1-.3.29h-.58A.29.29,0,0,1,18.82,9.71Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotiInitiatives);
export default __webpack_public_path__ + "static/media/noti-initiatives.2f40cc0c7077f7e33f16a4fdd25d4602.svg";
export { ForwardRef as ReactComponent };